import React from "react";
import {Button, Modal} from "react-bootstrap";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {anonymizeLoginUser} from "../../users/UsersSlice";
import {anonymizeLoginUserModalState, close, setEmailChecked} from "./AnonymizeLoginUserModalSlice";

const AnonymizeLoginUserModal = () => {
  const dispatch = useAppDispatch();
  const {isOpened, loginUser, isEmailChecked} = useAppSelector(anonymizeLoginUserModalState);

  const handleClose = () => {
    dispatch(close());
  };

  const handleAnonymizeLoginUser = () => {
    dispatch(anonymizeLoginUser(loginUser!));
  };

  const checkEmail = (event: React.KeyboardEvent<HTMLInputElement>) => {
    dispatch(setEmailChecked(event.currentTarget.value === loginUser?.email));
  };

  return (
    <Modal show={isOpened} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Anonymize login user</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>Hash the personal data and move to 0 account</div>
        <div>
          Email: <span className="font-weight-bold">{loginUser?.email}</span>
        </div>
        <div>
          Id: <span className="font-weight-bold">{loginUser?.id}</span>
        </div>
        <div>
          Email address:
          <input type="email" className="form-control" id="email" onKeyUp={checkEmail} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button className="btn btn-danger" disabled={!isEmailChecked} onClick={handleAnonymizeLoginUser}>
          Anonymize login user
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AnonymizeLoginUserModal;
